import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const createRoute = createAsyncThunk("createRoute", async (values, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`route`, values);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const CreateRouteSlice = createSlice({
	name: "CreateRouteSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreateRouteState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createRoute.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createRoute.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createRoute.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCreateRouteState } = CreateRouteSlice.actions;
export default CreateRouteSlice.reducer;
